import validate from '@vlabs/shared/validators';

const integerValidationRules = {
  validate: (value) => {
    const result = validate.integer()(value);

    if (result !== true) return result;
    if (Number(value) < 0) return validate.gte(0).message;

    return true;
  },
};

const numberValidationRules = {
  validate: (value) => {
    const result = validate.number()(value);

    if (result !== true) return result;
    if (Number(value) < 0) return validate.gte(0).message;
    if (Number(value) > 100) return validate.lte(100).message;

    return true;
  },
};

export const SCORE_FIELDS = {
  crowd: {
    gte: 'event^people_count__gte:integer',
    lt: 'event^people_count__lt:integer',
    labelKey: 'videoAnalytics:people_count.label',
    validationRules: integerValidationRules,
  },
  fight: {
    gte: 'event^fight_score__gte:numeric',
    lt: 'event^fight_score__lt:numeric',
    labelKey: 'videoAnalytics:fight_score.label %',
    validationRules: numberValidationRules,
  },
  weapon: {
    gte: 'event^weapon_score__gte:numeric',
    lt: 'event^weapon_score__lt:numeric',
    labelKey: 'videoAnalytics:weapon_score.label %',
    validationRules: numberValidationRules,
  },
  fire: {
    gte: 'event^fire_score__gte:numeric',
    lt: 'event^fire_score__lt:numeric',
    labelKey: 'videoAnalytics:fire_score.label %',
    validationRules: numberValidationRules,
  },
  facecover: {
    gte: 'event^facecover_score__gte:numeric',
    lt: 'event^facecover_score__lt:numeric',
    labelKey: 'videoAnalytics:facecover_score.label %',
    validationRules: numberValidationRules,
  },
  niqab: {
    gte: 'event^niqab_score__gte:numeric',
    lt: 'event^niqab_score__lt:numeric',
    labelKey: 'videoAnalytics:niqab_score.label %',
    validationRules: numberValidationRules,
  },
  balaclava: {
    gte: 'event^balaclava_score__gte:numeric',
    lt: 'event^balaclava_score__lt:numeric',
    labelKey: 'videoAnalytics:balaclava_score.label %',
    validationRules: numberValidationRules,
  },
  other: {
    gte: 'event^other_score__gte:numeric',
    lt: 'event^other_score__lt:numeric',
    labelKey: 'videoAnalytics:other_score.label %',
    validationRules: numberValidationRules,
  },
  lying: {
    gte: 'event^lying_score__gte:numeric',
    lt: 'event^lying_score__lt:numeric',
    labelKey: 'videoAnalytics:lying_score.label %',
    validationRules: numberValidationRules,
  },
  handsup: {
    gte: 'event^handsup_score__gte:numeric',
    lt: 'event^handsup_score__lt:numeric',
    labelKey: 'videoAnalytics:handsup_score.label %',
    validationRules: numberValidationRules,
  },
  fall: {
    gte: 'event^fall_score__gte:numeric',
    lt: 'event^fall_score__lt:numeric',
    labelKey: 'videoAnalytics:fall_score.label %',
    validationRules: numberValidationRules,
  },
};
